import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { APP_ROUTES, ONBOARDING_ROUTES } from 'src/app/shared/enums/appRoutes.enum';
import { Observable, filter, take } from 'rxjs';
import { map } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route): Observable<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const path = route.routeConfig?.path;
  const isAuthRoute =
    path === ONBOARDING_ROUTES.LOGIN ||
    path === ONBOARDING_ROUTES.REGISTER ||
    path === ONBOARDING_ROUTES.MAGIC_LINK;

  return authService.isAuthenticated().pipe(
    filter(isAuthenticated => isAuthenticated !== null),
    take(1),
    map(isAuthenticated => {
      if (isAuthRoute) {
        if (isAuthenticated) {
          router.navigate([APP_ROUTES.HOME]);
          return false;
        }
        return true;
      } else {
        if (!isAuthenticated) {
          router.navigate([ONBOARDING_ROUTES.LOGIN]);
          return false;
        }
        return true;
      }
    })
  );
};
